module.exports = __webpack_public_path__ + "media/domenj/pasos_juriteca-ce6f116d.png";